import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { completeGoogle } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      setError("Missing session. Please try signing in again.");
      return;
    }

    (async () => {
      try {
        await completeGoogle(sessionId);
        toast.success("Karibu! You're signed in with Google.");
        // Remove the fragment and go to feed
        window.history.replaceState({}, document.title, "/feed");
        navigate("/feed", { replace: true });
      } catch (e) {
        console.error(e);
        setError("Google sign-in failed. Please try again.");
      }
    })();
  }, [completeGoogle, navigate]);

  return (
    <div data-testid="auth-callback-page" className="grid min-h-[60vh] place-items-center px-4">
      <div className="max-w-md rounded-2xl border border-black/5 bg-white p-8 text-center shadow-sm">
        {error ? (
          <>
            <div className="text-lg font-semibold text-[#C1292E]" style={{ fontFamily: "Outfit" }}>
              Sign-in issue
            </div>
            <p className="mt-2 text-sm text-[#4A4A4A]">{error}</p>
            <button
              onClick={() => navigate("/login")}
              className="jirani-pill mt-6 rounded-full bg-[#D95D39] px-5 py-2 text-white"
            >
              Back to login
            </button>
          </>
        ) : (
          <>
            <div className="mx-auto h-10 w-10 animate-pulse rounded-full bg-[#D95D39]/60" />
            <div className="mt-4 text-lg font-semibold text-[#1A1A1A]" style={{ fontFamily: "Outfit" }}>
              Finishing sign-in…
            </div>
            <p className="mt-1 text-sm text-[#4A4A4A]">Karibu. Setting up your neighborhood.</p>
          </>
        )}
      </div>
    </div>
  );
}
